<template>
    <main>
        <v-container class="grey lighten-4 fill-height" fluid>
        <v-row>
            <v-col cols="12" sm="8" md="4" class="mx-auto" >
                    <v-card class="elevation-12 ma-3">
                  <v-toolbar
                  color="primary"
                  dark
                  flat>
                  <v-toolbar-title>Logga in</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-form ref="form">
                <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Din mail"
              outlined
                    required
                ></v-text-field>

                <v-text-field
                    v-model="password"
                    type="password"
                    :rules="passRules"
                    label="Lösenord"
                     outlined
                    required
                ></v-text-field>
                <p>
                    <a
                        @click="$router.replace('/resetpassword')"
                        >Glömt ditt lösenord?</a
                    >
                </p>
                <sociallogin />
                <alert />
                <v-btn
                    class="my-5"
                    v-on:click="submit"
                    :loading="loading"
                    v-show="!createmeeting"
                    block
                >
                    Logga in
                </v-btn>
                <router-link to="/register" style="text-decoration: none;">
                    <v-btn
                        v-show="!createmeeting"
                        color="success"
                        style="margin-top:6px;"
                        block
                    >
                        Registrera dig
                    </v-btn>
                </router-link>
            </v-form>
                </v-card-text>
            </v-card>
            </v-col>
        </v-row>
        </v-container>
        <v-container v-show="!createmeeting" style="width:20%">
            <adds />
        </v-container>
    </main>
</template>

<script>
import store from "../../store";
import sociallogin from "./sociallogin";
import adds from "../ads";
import alert from "../layout/alert";
export default {
    components: {
        sociallogin,
        adds,
        alert
    },
    store: store,
    name: "Login",
    props: ["createmeeting"],
    created: function() {
        this.email = this.$store.state.email;
        if (this.$store.state.isLoggedIn && !this.createmeeting)
            this.$router.replace("/dashboard");
    },
    data: () => ({
        loading: false,
        email: "",
        cnfpass: "",
        emailRules: [
            v => !!v || "Din mail krävs",
            v => /.+@.+\..+/.test(v) || "Email måste vara giltig"
        ],
        select: null,
        password: "",
        passRules: [
            v => !!v || "lösenord krävs",
            v => v.length >= 8 || "Lösenordet måste vara större än 8 tecken"
        ]
    }),
    methods: {
        validate() {
            this.$refs.form.validate();
        },
        async submit() {
            await this.validate();
            let bodyFormData = new FormData();
            bodyFormData.set("email", this.email);
            bodyFormData.set("password", this.password);
            const config = {
                method: "post",
                url: "",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };

            if (this.$refs.form.validate()) {
                await this.$store
                    .dispatch("login", config)
                    .then(() => (this.loading = false));
                this.loading = false;
                if (this.createmeeting) this.loading = false;
                else this.$router.replace("/dashboard");
            } else {
                this.store.state.showAlert = true;
                this.store.state.alertMsg = "Please Fill Appropreate Data";
                this.store.state.alertType = "error";
            }
        }
    }
};
</script>
